interface PageLayoutProps {
  children: React.ReactNode;
}

/** Container da página com espaçamento generoso (padrão TailAdmin): margem em volta de todo o conteúdo */
export function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="px-6 py-6 sm:px-8 sm:py-8 lg:px-10 lg:py-8 mx-auto w-full max-w-screen-2xl">
      {children}
    </div>
  );
}
